import store from "@/state/store";

import { isPendingOnboardMerchant, isPendingActivationUser, getOnboardingRedirect, isOnboardingPaused } from "./views/onboarding/onboarding";

export default [
    {
        path: "/",
        name: "default",
        meta: {
            authRequired: true,
        },
        beforeEnter(routeFrom, routeTo, next) {
          const userPermissions = JSON.parse(localStorage.getItem('menuDisplayAuthorities'));
          const menuOrder = [
            { label: 'Create Order', order: 1, path: "merchant-order" },
            { label: 'Orders', order: 2, path: "order-history-page" },
            { label: 'Static QR', order: 3, path: "static-qr-dashboard" },
            { label: 'Analytics', order: 4, path: "graph-report" },
            { label: 'Campaigns', order: 5, path: "compaigns-list" },
            { label: 'Finance', order: 6, path: "finance-dashboard" },
            { label: 'Profiles', order: 7, path: "profile-dashboard" },
            { label: 'Action History', order: 8, path: "action-history" },
          ];

          // Filter menu items based on user permissions and sort them by order
          const sortedMenuItems = menuOrder
            .filter(item => userPermissions.includes(item.label))
            .sort((a, b) => a.order - b.order);

          const defaultComponentPath = sortedMenuItems.length != 0 ? sortedMenuItems[0].path : '/';
          next({ name: defaultComponentPath });
        },
    },

    {
        path: "/main",
        name: "main",
        meta: {
            authRequired: true,
        },
        component: () => import("./views/dashboards/default"),
    },
    {
        path: "/login",
        name: "login",
        component: () => import("./views/account/login"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "default"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/signup",
        name: "signup",
        component: () => import("./views/onboarding/signup.vue"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "default" });
                } else {
                    // Continue to the signup page
                    next();
                }
            },
        },
    },
    {
        path: "/onboarding-unavailable",
        name: "onboarding-unavailable",
        component: () => import("./views/onboarding/onboarding-unavailable.vue"),
        beforeEnter(routeTo, routeFrom, next) {
            if (isOnboardingPaused()) {
                next();
            } else {
                next(getOnboardingRedirect() || { name: "signup" });
            }
        },
    },
    {
        path: "/update-mobile",
        name: "update-mobile",
        component: () => import("./views/onboarding/update-mobile.vue"),
        meta: {
            authRequired: true,
        },
        beforeEnter(routeTo, routeFrom, next) {
            if (isPendingActivationUser()) {
                next();
            } else {
                next(getOnboardingRedirect() || { name: "default" });
            }
        },
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("./views/account/register"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "default"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("./views/account/forgot-password"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "default"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/merchant/user/password-reset",
        name: "Password Reset",
        component: () => import("./views/account/reset-password"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "default"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/merchant/user/password-create",
        name: "Password Create",
        component: () => import("./views/account/create-password"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "default"});
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/logout",
        name: "logout",
        component: () => import("./views/account/logout"),
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch("auth/logOut");
                } else {
                    store.dispatch("authfack/logout");
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
                    route.push("/login")
                );
                // Navigate back to previous page, or home as a fallback
                next(
                    authRequiredOnPreviousRoute ? {name: "default"} : {...routeFrom}
                );
            },
        },
    },
    {
        path: "/dashboard/merchant/order",
        name: "merchant-order",
        meta: {authRequired: true},
        component: () => import("./views/dashboards/billing/merchant-order.vue"),
        beforeEnter(routeTo, routeFrom, next) {
            let userAuthorities = JSON.parse(localStorage.getItem('profileManagementAuthorities'));
            let decodedToken = [];
            if (userAuthorities) {
              decodedToken = userAuthorities.authorities || [];
            }
            if (Array.isArray(decodedToken)) {
              next();
            }
        },
    },

    {
        path: "/dashboard/merchant/order/qrcode",
        name: "qr-code-scan",
        meta: {authRequired: true},
        component: () => import("./views/dashboards/billing/qr-code-scan.vue"),
    },

    {
        path: "/dashboard/finance",
        name: "finance-dashboard",
        meta: {authRequired: true},
        component: () => import("./views/dashboards/finance/finance"),
        beforeEnter(routeTo, routeFrom, next) {
            let userAuthorities = JSON.parse(localStorage.getItem('profileManagementAuthorities'));
            let decodedToken = [];
            if (userAuthorities) {
              decodedToken = userAuthorities.authorities
            }
            if (Array.isArray(decodedToken) && decodedToken.includes('v-musr-acc')) {
              next();
            }
        },
    },

    {
        path: "/dashboard/orders/list",
        name: "order-history-page",
        meta: {authRequired: true},
        component: () => import("./views/dashboards/orders/order-page.vue"),
        beforeEnter(routeTo, routeFrom, next) {
            let userAuthorities = JSON.parse(localStorage.getItem('profileManagementAuthorities'));
            let decodedToken = [];
            if (userAuthorities) {
              decodedToken = userAuthorities.authorities
            }
            if (Array.isArray(decodedToken) && (decodedToken.includes('ls-ow-odr') || 
              decodedToken.includes('ls-br-odr') || 
              decodedToken.includes('ls-al-odr'))) {
              next();
            }
        },
    },
    {
        path: "/dashboard/merchant/order/verified/:id",
        name: "merchant-order-verified",
        meta: {authRequired: true},
        component: () => import("./views/dashboards/billing/order-verified.vue"),
    },
    {
        path: "/dashboard/merchant/order/failed/:id",
        name: "merchant-order-verification-failed",
        meta: {authRequired: true},
        component: () => import("./views/dashboards/billing/order-failed.vue"),
    },

  {
    path: "/dashboard/profile",
    name: "profile-dashboard",
    component: () => import("./views/dashboards/manage-profile/profile"),
    meta: {authRequired: true,
    },
    beforeEnter(routeTo, routeFrom, next) {
      let userAuthorities = JSON.parse(localStorage.getItem('profileManagementAuthorities'));
      let decodedToken = [];
      if (userAuthorities) {
        decodedToken = userAuthorities.authorities
      }
      if (Array.isArray(decodedToken) && decodedToken.includes('ls-musr')) {
        next();
      }
    },
  },
  {
    path: "/dashboard/history/action-history",
    name: "action-history",
    component: () => import("./views/dashboards/history/action-history"),
    meta: {authRequired: true},
    beforeEnter(routeTo, routeFrom, next) {
        let userAuthorities = JSON.parse(localStorage.getItem('profileManagementAuthorities'));
        let decodedToken = [];
        if (userAuthorities) {
          decodedToken = userAuthorities.authorities
        }
        if (Array.isArray(decodedToken) && (decodedToken.includes('ls-ow-actlog') || 
          decodedToken.includes('ls-br-actlog') || 
          decodedToken.includes('ls-al-actlog'))) {
          next();
        }
    },
  },
  {
    path: "/dashboard/reports/graph-report",
    name: "graph-report",
    component: () => import("./views/dashboards/reports/graph-report"),
    meta: {authRequired: true},
    beforeEnter(routeTo, routeFrom, next) {
        let userAuthorities = JSON.parse(localStorage.getItem('profileManagementAuthorities'));
        let decodedToken = [];
        if (userAuthorities) {
          decodedToken = userAuthorities.authorities
        }
        if (Array.isArray(decodedToken) && (decodedToken.includes('ls-br-order-trend') || 
          decodedToken.includes('ls-al-order-trend'))) {
          next();
        }
    },
  },
  {
    path: "/dashboard/compaigns/list",
    name: "compaign-list",
    meta: {authRequired: false},
    component: () => import("./views/dashboards/compaigns/compaign-list.vue"),
    beforeEnter(routeTo, routeFrom, next) {
        let userAuthorities = JSON.parse(localStorage.getItem('profileManagementAuthorities'));
        let decodedToken = [];
        if (userAuthorities) {
          decodedToken = userAuthorities.authorities
        }
        if (Array.isArray(decodedToken) && (decodedToken.includes('ls-br-order-trend') || 
          decodedToken.includes('ls-al-order-trend'))) {
          next();
        }        
    },
  },
  {
    path: "/dashboard/static-qr",
    name: "static-qr-dashboard",
    component: () => import("./views/dashboards/static-qr/qr-dashboard.vue"),
    meta: {authRequired: false},
    },
  {
    path: "/dashboard/tools/plugins",
    name: "plugins",
    component: () => import("./views/dashboards/tools/plugins.vue"),
    meta: {authRequired: true},
  },
     {
    path: "/verification/ssu",
    name: "verification",
    meta: { authRequired: true },
    component: () => import("./views/verification/ssu.vue"),
        beforeEnter(routeTo, routeFrom, next) {
            if (isPendingActivationUser()) {
                // Mobile number must be verified before onboarding.
                next(getOnboardingRedirect());
            } else if (isPendingOnboardMerchant()) {
                next();
            } else {
                next({ name: "default" });
            }
        },
    }
 ];
